<template>
  <print-template :viewFooter="false" :viewExtraFooter="true">
    <table id="top_table" class="table-bordered">
      <thead>
        <tr>
          <th colspan="4" style="padding: 10px; font-size: 20px">
            <b>MATERIALS RECEIVING INSPECTION SHEET</b>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><b>DATE RECEIVED</b></td>
          <td>
            {{ inspectionSheet.date_received | dateFormat("DD MMMM YYYY") }}
          </td>
          <td><b>TIME RECEIVED</b></td>
          <td>{{ inspectionSheet.time_received | dateFormat("hh:mm A") }}</td>
        </tr>
        <tr>
          <td><b>SUPPLIER NAME</b></td>
          <td>{{ inspectionSheet.supplier_name }}</td>
          <td><b>TX P.O. NUMBER</b></td>
          <td>{{ inspectionSheet.po_no }}</td>
        </tr>
        <tr>
          <td>
            <b>DELIVERY NOTE NO.</b>
          </td>
          <td>{{ inspectionSheet.delivery_note_no }}</td>
          <td>
            <b>INVOICE NO.</b>
          </td>
          <td>{{ inspectionSheet.invoice_no }}</td>
        </tr>
        <tr>
          <td>
            <b>FREIGHT FORWARDER</b>
          </td>
          <td>
            {{ inspectionSheet.freight_forwarder }}
          </td>
          <td>
            <b>BATCH NO.</b>
          </td>
          <td>{{ inspectionSheet.batch_no }}</td>
        </tr>
      </tbody>
    </table>
    <table class="table-bordered mt-1">
      <thead>
        <tr>
          <th colspan="6"></th>
          <th width="50px">Y</th>
          <th width="50px">N</th>
          <th width="50px">N/A</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="6">
            <b style="display: block; margin-left: 80px">Documentation:</b>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="6" class="text-right">
            Packing List/Del. Note: The following matches with the Purchase
            Order;
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_po == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_po == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_po == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="text-right">Part Number</td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_part_no == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_part_no == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_part_no == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="6" class="text-right">Description</td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_part_description == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_part_description == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.match_part_description == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="9">
            <span style="height: 19px; display: block;"></span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <b style="display: block; margin-left: 80px">Certificate:</b>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>EASA Form 1</td>
          <td class="text-center"><fa :icon="getIcon(1)"></fa></td>
          <td>FAA 8130-3</td>
          <td class="text-center"><fa :icon="getIcon(3)"></fa></td>
          <td>Certificate of Conformity</td>
          <td class="text-center"><fa :icon="getIcon(5)"></fa></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>GCAA AW Form 1</td>
          <td class="text-center"><fa :icon="getIcon(2)"></fa></td>
          <td>TCAA Form</td>
          <td class="text-center"><fa :icon="getIcon(4)"></fa></td>
          <td>Others</td>
          <td class="text-center"><fa :icon="getIcon(6)"></fa></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="9">
            <span style="height: 19px; display: block;"></span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <b style="display: block; margin-left: 80px">Packing Condition</b>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="6">
            <span style="display: block; margin-left: 150px"
              >Hidden damage</span
            >
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.hidden_damage == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.hidden_damage == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.hidden_damage == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <span style="display: block; margin-left: 150px"
              >Visible damage</span
            >
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.visible_damages == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.visible_damages == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.visible_damages == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <span style="display: block; margin-left: 150px"
              >Adequate protective packaging</span
            >
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.adequate_packaging == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.adequate_packaging == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.adequate_packaging == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="9">
            <span style="height: 19px; display: block;"></span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <b style="display: block; margin-left: 80px"
              >Material physical inspection</b
            >
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="6">
            <span style="display: block; margin-left: 150px"
              >Item damaged, nicks, dents, breaks, etc.</span
            >
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.item_damage == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.item_damage == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.item_damage == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <span style="display: block; margin-left: 150px"
              >Apparent Leakage</span
            >
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.apparent_leakage == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.apparent_leakage == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.apparent_leakage == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="6">
            <span style="display: block; margin-left: 150px"
              >Quantity complete</span
            >
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.quantity_complete == 1"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.quantity_complete == 0"
              class="el-icon-check"
            ></span>
          </td>
          <td class="text-center">
            <span
              v-if="inspectionSheet.quantity_complete == 2"
              class="el-icon-check"
            ></span>
          </td>
        </tr>
        <tr>
          <td colspan="9">
            <p><b>REMARKS:</b> {{ inspectionSheet.remarks }}</p>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table-bordered mt-1">
      <tbody>
        <tr>
          <td style="vertical-align: top" width="33%">
            RECEIVED &amp; INSPECTED BY:
          </td>
          <td style="vertical-align: top">
            {{ inspectionSheet.requested_by }}
          </td>
          <td style="vertical-align: top" width="33%">
            Signature:
            <img
              class="img-signature img-responsive"
              :src="imageUrl"
              alt="Signature"
            />
          </td>
        </tr>
        <tr>
          <td>POSITION</td>
          <td colspan="2">{{ inspectionSheet.requested_by_position }}</td>
        </tr>
        <tr>
          <td>DATE</td>
          <td colspan="2">
            {{ inspectionSheet.date_received | dateFormat("DD MMMM YYYY") }}
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <template v-slot:extrafooter>
      <span class="extra-footer">TXSF-01 Rev. 1, 29 May 2016</span>
    </template> -->
  </print-template>
</template>

<script>
import PrintTemplate from "@/components/PrintTemplate.vue";
import InspectionSheet from "@/models/InspectionSheet";
export default {
  name: "inspectionSheetPrint",
  components: {
    PrintTemplate
  },
  data() {
    return {
      inspectionSheet: new InspectionSheet(),
      imageUrl: ""
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      InspectionSheet.fetch(this.$route.params.id).then(resp => {
        this.inspectionSheet = new InspectionSheet(resp);
        this.imageUrl = "data:image;base64, " + resp.image;
      });
    }
  },
  methods: {
    getIcon(index) {
      var val = 0;
      for (let v of this.inspectionSheet.certificates) {
        if (v == index) {
          val = 1;
        }
        if (val == 1) break;
      }
      if (val == 1) {
        return ["far", "check-square"];
      } else {
        return ["far", "square"];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
table td {
  font-size: 14px;
}
p {
  margin: 0;
  min-height: 80px;
}
.img-signature {
  max-height: 50px;
  margin-left: 2px;
  float: right;
}
@media screen {
  #top_table {
    margin-top: 15px;
  }
  .extra-footer {
    width: 100%;
    display: block;
    text-align: left;
  }
}
@media print {
  #top_table {
    margin-top: 0;
  }
  .extra-footer {
    width: 100%;
    display: block;
    text-align: left;
    margin-left: 14mm;
  }
}
</style>
